import React from 'react'
import styles from './StepNumber.module.scss'

const STEP_DIGITS = 2

export const StepNumber: React.FC<{ number: number }> = ({ number }) => (
  <span className={styles.step}>{String(number).padStart(STEP_DIGITS, '0')}</span>
)
